<template>
  <v-container v-if="showForm" class="grey lighten-5">
    <v-row class="justify-start">
      <div class="FormCard-container bg-lightYellow pa-8">
        <p class="ma-0 mb-4 f-12 primary--text">Cadastro de SEPA</p>
        <v-form v-model="form.isFormValid">
          <v-text-field
            label="Nome"
            :rules="rules"
            v-model="form.account_name"
            background-color="#F7F7F7"
            hide-details="auto"
            class="mt-10"
            solo
            flat
          />
          <v-text-field
            label="Código IBAN"
            v-model="form.iban_code"
            :rules="sepaNumberRules"
            background-color="#F7F7F7"
            hide-details="auto"
            class="mt-6"
            solo
            flat
          />
          <div class="text-center">
            <div class="acept-terms">
              <v-checkbox v-model="form.terms_accepted"> </v-checkbox>
              <template> <TermsModalDialog /> </template>
            </div>
          </div>
          <div class="d-flex align-center justify-space-around text-center">
            <v-btn
              @click="processCreditCard"
              class="br-8 mt-8"
              height="40"
              width="170"
              color="primary"
            >
              Cancelar
            </v-btn>
            <v-btn
              @click="saveSepadMethod(form)"
              :disabled="!form.terms_accepted || isLoading || !form.isFormValid"
              class="br-8 mt-8"
              height="40"
              width="170"
              color="secondary"
            >
              Salvar
            </v-btn>
          </div>
        </v-form>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import TermsModalDialog from './TermsModalDialog.vue';

export default {
  components: {
    TermsModalDialog,
  },
  props: {
    type: { type: String },
    saveSepadMethod: { type: String },
    showForm:  { type: Boolean }
  },
  data() {
    return {
      showForm: false,
      form: {
        terms_accepted: false,
        isFormValid: false,
        id: '',
        iban_code: '',
        account_name: '',
      },
      rules: [(v) => !!v || 'Esse campo é obrigatório'],
      sepaNumberRules: [
        (v) => !!v || 'Esse campo é obrigatório',
        (v) =>
          v.length < 25 ? 'O credito direito (sepa) tem que ser digitado completamente' : true,
      ],
    };
  },
  methods: {
    show(formSepaMethod = {}) {
      this.showForm = true;
      this.form = {
        isFormValid: !formSepaMethod.id,
        iban_code: formSepaMethod.iban,
        account_name: formSepaMethod.name,
        ...formSepaMethod,
      };
    },
    close() {
      this.showForm = false;
    },
    processCreditCard() {
      this.showForm = false;
    },
  },
};
</script>

<style scoped>
.FormCard-container {
  width: 100%;
  max-width: 526px;
  background-color: #fffde3;
}
.acept-terms {
  display: flex;
  align-items: center;
}
</style>
